import { Checkbox } from '../ui/checkbox';

export function ChatSearchToggle({ searchMode, onToggle }) {
  return (
    <div className="flex items-center gap-2">
      <Checkbox
        id="search-previous-conversations-toggle"
        data-testid="search-previous-conversations-toggle"
        checked={searchMode}
        onCheckedChange={(checked) => onToggle(Boolean(checked))}
      />
      <label
        htmlFor="search-previous-conversations-toggle"
        className="cursor-pointer select-none text-sm text-zinc-400 transition-colors hover:text-white"
      >
        Rechercher dans de précédentes conversations
      </label>
    </div>
  );
}
